import type { LucideIcon } from "lucide-react";
import {
  Facebook,
  Instagram,
  Youtube,
  Linkedin,
  Twitter,
  Music2,          // TikTok stand-in
  MessageCircle,   // Threads stand-in
  Send,            // Telegram / bluesky-ish
  Ghost,           // Snapchat stand-in
  Hash,            // Reddit stand-in
  Palette,         // Pinterest stand-in
  Globe,           // default
  Cloud,           // Bluesky
  BookOpen,        // Tumblr
  Gamepad2,        // Discord
  Store,           // Google Business Profile
  Radio,           // WeChat / LINE broadcast
  Feather,         // Weibo
  MessagesSquare,  // VK
} from "lucide-react";

export interface PlatformIcon {
  icon: LucideIcon;
  bg: string;
}

export const PLATFORM_ICONS: Record<string, PlatformIcon> = {
  facebook:        { icon: Facebook,       bg: "bg-[#1877F2]" },
  instagram:       { icon: Instagram,      bg: "bg-gradient-to-tr from-[#FEDA75] via-[#FA7E1E] to-[#D62976]" },
  youtube:         { icon: Youtube,        bg: "bg-[#FF0000]" },
  threads:         { icon: MessageCircle,  bg: "bg-black" },
  linkedin:        { icon: Linkedin,       bg: "bg-[#0A66C2]" },
  tiktok:          { icon: Music2,         bg: "bg-black" },
  twitter:         { icon: Twitter,        bg: "bg-black" },
  pinterest:       { icon: Palette,        bg: "bg-[#E60023]" },
  bluesky:         { icon: Cloud,          bg: "bg-[#0085FF]" },
  tumblr:          { icon: BookOpen,       bg: "bg-[#001935]" },
  reddit:          { icon: Hash,           bg: "bg-[#FF4500]" },
  snapchat:        { icon: Ghost,          bg: "bg-[#FFFC00]" },
  telegram:        { icon: Send,           bg: "bg-[#26A5E4]" },
  discord:         { icon: Gamepad2,       bg: "bg-[#5865F2]" },
  google_business: { icon: Store,          bg: "bg-[#4285F4]" },
  wechat:          { icon: Radio,          bg: "bg-[#07C160]" },
  weibo:           { icon: Feather,        bg: "bg-[#E6162D]" },
  vk:              { icon: MessagesSquare, bg: "bg-[#0077FF]" },
  line:            { icon: Radio,          bg: "bg-[#06C755]" },
  default:         { icon: Globe,          bg: "bg-slate-600" },
};
